import {Component, OnInit} from '@angular/core';
import {ModalController} from '@ionic/angular';

@Component({
  selector: 'app-user-edit',
  templateUrl: './user-edit.page.html',
  styleUrls: ['./user-edit.page.scss'],
})
export class UserEditPage implements OnInit {
  user: any;

  constructor(public modalController: ModalController) {
  }

  ngOnInit() {
  }

  editUser(value: any) {

  }

  async close() {
    await this.modalController.dismiss();

  }
}
